<template>
  <component v-if="widgetName" :is="widgetName" :config="widgetConfig" />
</template>

<script setup>
import { provide, computed } from "vue";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const widgetName = computed(() => props.data.type);
const widgetConfig = computed(() => JSON.parse(props.data.config));

provide("widgetName", widgetName.value);
</script>